import React from 'react';
import styles from './Marker.module.css';
import { AlarmSeverity, GeoLocationPoint, Location } from 'model';
import classnames from 'classnames';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { StatusIndicator } from '../StatusIndicator';


type MarkerProps = {
  markerId:       string;
  lat:            number;
  lng:            number;
  cluster:        GeoLocationPoint<Location>;
  totalPoints:    number;
  onClick?:       (isCluster: boolean, cluster: GeoLocationPoint<Location>) => void;
}

export const Marker: React.FC<MarkerProps> = ({markerId, cluster, totalPoints, onClick}) => {
  const { cluster: isCluster, point_count: pointCount } = cluster.properties;
  const critical = cluster.properties.pendingStats.criticalCount;
  const warning = cluster.properties.pendingStats.warningCount;
  const showCritical = critical > 0;

  return (
    <OverlayTrigger
      key={`marker-tooltip-${markerId}`}
      placement={'bottom'}
      overlay={
        <Tooltip id={`marker-tooltip-${markerId}`} className={styles.tooltip} >
          <div className={styles.tooltipContent}>
            <div className={styles.tooltipRow}>
              <StatusIndicator className={styles.statusIndicator} severity={AlarmSeverity.CRITICAL} />
              <div className={styles.tooltipInfo}>Critical alerts: <strong>{critical}</strong></div>
            </div>
            <div className={styles.tooltipRow}>
              <StatusIndicator className={styles.statusIndicator} severity={AlarmSeverity.WARNING} />
              <div className={styles.tooltipInfo}>Warning alerts: <strong>{warning}</strong></div>
            </div>
          </div>
        </Tooltip>
      }
    >
      <div
        className={classnames(
          { [styles.regularMarker]: !isCluster },
          { [styles.clusterMarker]: isCluster },
          { [styles.critical]: showCritical },
          { [styles.warning]: !showCritical },
        )}
        style={ isCluster ? {
          width: `${10 + (pointCount as number / totalPoints) * 20}px`,
          height: `${10 + (pointCount as number / totalPoints) * 20}px`
        } : {}}
        onClick={() => onClick ? onClick(isCluster, cluster) : {}}
      >
        { showCritical ? critical : warning }
      </div>
    </OverlayTrigger>
  );
}
